import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from 'firebase/app';

import { get, includes, find } from 'lodash';
// Add the Firebase services that you want to use
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/performance';
import 'firebase/storage';
import { Query } from '../graphql';
import GET_CREDENTIALS from '../../queries/GET_CREDENTIALS';

export const FirebaseContext = React.createContext({});
export class FirebaseProvider extends React.Component {
    render () {
        const { children } = this.props;
        const currentPath = window.location.pathname;
        const publicPaths = ['/', '/login', '/redirect', '/search', '/marketplace'];
        
        // Verificar si es una ruta pública o comienza con una ruta pública
        const isPublicPath = publicPaths.some(publicPath => 
            currentPath === publicPath || currentPath.startsWith(publicPath + '/')
        );
        
        if (isPublicPath) {
            return <Fragment>{ children }</Fragment>;
        };

        return (
            <Query
                query={GET_CREDENTIALS}
                variables={{
                    keys: [
                        'FIREBASE_API_KEY',
                        'FIREBASE_AUTH_DOMAIN',
                        'FIREBASE_APP_ID',
                        'FIREBASE_DATABASE_URL',
                        'FIREBASE_MESSAGING_SENDER_ID',
                        'FIREBASE_PROJECT_ID',
                        'FIREBASE_STORAGE_BUCKET',
                        'SHOPPERS_PROFILE_ID'
                    ]
                }}
            >
                {({ data, loading }) => {
                    if (loading) return null;
                    const credentials = get(data, 'getCredentials.data', []);
                    const getCredentialValue = id => get(find(credentials, ({ key }) => includes([key], id)), 'value');
                    const firebaseConfig = {
                        apiKey: getCredentialValue('FIREBASE_API_KEY'),
                        appId: getCredentialValue('FIREBASE_APP_ID'),
                        authDomain: getCredentialValue('FIREBASE_AUTH_DOMAIN'),
                        databaseURL: getCredentialValue('FIREBASE_DATABASE_URL'),
                        messagingSenderId: getCredentialValue('FIREBASE_MESSAGING_SENDER_ID'),
                        projectId: getCredentialValue('FIREBASE_PROJECT_ID'),
                        storageBucket: getCredentialValue('FIREBASE_STORAGE_BUCKET')
                    };
                    sessionStorage.setItem('SHOPPERS_PROFILE_ID', getCredentialValue('SHOPPERS_PROFILE_ID'));
                    // Initialize Firebase
                    if (!firebase.apps.length) {
                        firebase.initializeApp(firebaseConfig);
                        process.browser && firebase.firestore().enablePersistence({ synchronizeTabs: true });
                    }
                    return (
                        <FirebaseContext.Provider value={{ firebase: firebase.firestore(), database: firebase.database(), performance: firebase.performance(), storage: firebase.storage() }}>
                            {children}
                        </FirebaseContext.Provider>
                    );
                }}
            </Query>
        );
    }
}

FirebaseProvider.propTypes = {
    children: PropTypes.any
};
